module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "404.213a0c94.svg";